import { ChangeDetectionStrategy, Component, Inject, ViewEncapsulation } from "@angular/core";
import {
	MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
	MatLegacyDialogRef as MatDialogRef,
} from "@angular/material/legacy-dialog";

import { SgaLoginMessages } from "../../login-ui/login-ui.model";

@Component({
	selector: "obg-m-sga-login-notice-modal",
	templateUrl: "./sga-login-notice-modal.component.html",
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class SgaLoginNoticeModalComponent {
	constructor(
		@Inject(MAT_DIALOG_DATA) public data: SgaLoginMessages | undefined,
		private dialogRef: MatDialogRef<SgaLoginNoticeModalComponent>
	) {}

	closeDialog() {
		this.dialogRef.close();
	}
}
